// --------------------------------- start ReactRestService

import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

// const baseUrl = config.baseUrl;
// const service = 'jernygateway';

// krakend - KDesk
const baseUrl = config.baseUrl;
const service = 'journal';

class CalendarEventService extends ServiceBase {
    /**
     * Fetches all CalendarEvent for the current user.
     * @returns {Promise}
     */
    getCalendarEvent = () => {
        const url = `${baseUrl}/${service}/calEvent/event`;
        const config = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, config);
    };

    /**
     * Saves a new or updated CalendarEvent.
     * @param {object} dto - { rk?, title, body, format, templateVer }
     * @returns {Promise}
     */
    postCalendarEvent = (dto) => {
        const url = `${baseUrl}/${service}/calEvent/event`;
        const config = {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                'Content-Type': 'application/json',
            },
        };
        return agent.post(url, { data: dto }, config);
    };

    /**
     * Updates CalendarEvent
     * @param {object} req - { CalendarEvent }
     * @returns {Promise}
     */
    patchCalendarEvent = (req) => {
        const url = `${baseUrl}/${service}/calEvent/event`;
        const cfg = {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                'Content-Type': 'application/json',
            },
        };

        // Wrap in data envelope
        return agent.patch(url, { data: req }, cfg);
    };

    /**
     * Deletes a CalendarEvent by RK.
     *
     * @param {*} dto - { Rk }
     * @returns axios response
     */
    deleteCalendarEvent = (dto) => {
        const url = `${baseUrl}/${service}/calEvent/event`;
        const cfg = {
            data: { data: dto },
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return agent.delete(url, cfg);
    };
}

const calendarEventService = new CalendarEventService();
export default calendarEventService;

// --------------------------------- end ReactRestService
